import { FC } from 'react';
import { Controller, Control, FieldValues } from 'react-hook-form';
import { TextFieldProps } from '@mui/material';
import CheckboxAutocomplete from '@components/checkbox-autocomplete';
import { styles } from './styles';

type Props = {
  control: Control<FieldValues, any>;
  setVal: (newValue: string[]) => void;
  name: string;
  label: string;
  filterOptions: FilterOption[];
  disabled?: boolean;
  popupIcon?: JSX.Element;
  renderValueTitle?: boolean;
  selectedData: {
    state: string[];
  };
};

const RHFCheckboxSelect: FC<Props & TextFieldProps> = ({
  name,
  label,
  filterOptions,
  control,
  setVal,
  disabled,
  renderValueTitle,
  popupIcon,
  selectedData,
}) => (
  <Controller
    name={name}
    control={control}
    render={() => (
      <CheckboxAutocomplete
        options={selectedData}
        filterOptions={filterOptions}
        handleSelect={setVal}
        renderValueTitle={renderValueTitle}
        componentProps={{
          disabled,
          disableClearable: true,
          size: 'small',
          limitTags: 51,
          sx: styles.select,
          popupIcon,
          style: { width: '100%' },
        }}
        inputProps={{ label }}
      />
    )}
  />
);

export default RHFCheckboxSelect;
